import BoSungThongTinPage from './BoSungThongTinPage.jsx';
import BoSungThongTinLanhDaoPage from './BoSungThongTinLanhDaoPage.jsx';
import BoSungChuyenDonPage from './BoSungChuyenDonPage.jsx';

export {
  BoSungThongTinPage,
  BoSungThongTinLanhDaoPage,
  BoSungChuyenDonPage
}


// WEBPACK FOOTER //
// ./src/components/pages/bo-sung-thong-tin/index.js